import React from "react";
import { useSelector } from "react-redux";
import Table from "@mui/material/Table";
import TableContainer from "@mui/material/TableContainer";
import TableHeaderComponent from "./tableHeader";
import TableRowComponent from "./tableRow";

import { selectLocalization } from "@/store/store/selectors";

const TableComponent = (props) => {
  const { loading, stores, onPriceUpdateSuccess } = props;
  const localization = useSelector(selectLocalization);

  return (
    <TableContainer
      sx={{
        borderTopLeftRadius: 8,
        borderTopRightRadius: 8,
        maxHeight: "65vh",
      }}
    >
      <Table stickyHeader>
        <TableHeaderComponent />
        <TableRowComponent
          localization={localization}
          loading={loading}
          stores={stores}
          onPriceUpdateSuccess={onPriceUpdateSuccess}
        />
      </Table>
    </TableContainer>
  );
};

export default TableComponent;
